import {useState} from 'react';
import {colors, radii, transitions} from '../../common/theme';

export type SimpleButtonProps = {
  text: string;
  onClick: () => void;
  disabled?: boolean;
};

export const SimpleButton = ({onClick, text, disabled}: SimpleButtonProps) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <button
      type="button"
      onClick={disabled ? undefined : onClick}
      onMouseEnter={() => { if (!disabled) setIsHovered(true); }}
      onMouseLeave={() => setIsHovered(false)}
      style={{
        backgroundColor: disabled ? colors.primaryDisabledBg : colors.primary,
        color: disabled ? colors.primaryDisabledFg : '#000',
        border: `1px solid ${disabled ? colors.primaryDisabledBorder : 'transparent'}`,
        padding: '12px 20px',
        borderRadius: radii.md,
        fontSize: '0.9rem',
        fontWeight: 700,
        cursor: disabled ? 'not-allowed' : 'pointer',
        transition: `transform ${transitions.fast}, opacity ${transitions.fast}`,
        transform: isHovered ? 'scale(1.03)' : 'scale(1)',
        opacity: isHovered ? 0.9 : 1,
      }}>
      {text}
    </button>
  );
};
